<!-- ================二级代理-机构管理====================-->
<template>
    <div class="admin-screen-container">
        <div class="admin-title-container">机构列表</div>
        <div class="admin-btn-container">
            <div class="admin-btn-item" @click="createInstitution">添加机构</div>
            <div class="admin-btn-item" @click="importUser">用户导入</div>
            <div class="admin-btn-item right-start" @click="downloadTemplate">用户导入模板</div>
        </div>
        <div class="admin-search4-100">
            <div class="admin-search25"></div>
            <div class="admin-search25"></div>
            <div class="admin-search25"></div>
            <div class="admin-search25">
                <div class="admin-search25-item-input">
                    <el-input class="admin-input1" v-model="queryParams.orgName" placeholder="请输入机构名称" >
                        <template #append>
                            <el-button @click="handleQuery" class="name-search-btn"
                                       type="primary" icon="el-icon-search" />
                        </template>
                    </el-input>
                </div>
            </div>
        </div>
        <!--数据列表-->
        <div class="mt5">
            <el-table v-loading="loading"
                      cell-class-name="admin-table"
                      show-overflow-tooltip
                      height="calc(100vh - 255px)"
                      :data="dataList"
                      class="admin-table"
                      highlight-current-row>
                <el-table-column type="index"  fixed="left" align="center" label="序号" width="60" />
                <el-table-column width="200" label="机构名称" align="center" prop="orgName">
                    <template #default="scope">
                        <div :title="scope.row.orgName" style="color: #377f7f;"
                             class="text-one cursor">
                            {{ scope.row.orgName }}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column width="80" align="center" label="性质" prop="orgNature">
                    <template #default="scope">
                        <div type="success" v-if="scope.row.orgNature == 1">试用</div>
                        <div type="primary" v-if="scope.row.orgNature == 2">正式</div>
                    </template>
                </el-table-column>
                <el-table-column align="center" label="服务时限" width="280" prop="">
                    <template #default="scope">
                        <div>
                            {{ timestampToTime(scope.row.beginTime) }}至{{ timestampToTime(scope.row.endTime) }}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column width="100" align="center" label="机构类型" prop="orgType">
                    <template #default="scope">
                        <div type="success" v-if="scope.row.orgType == 1">组织</div>
                        <div type="primary" v-if="scope.row.orgType == 2">个人</div>
                    </template>
                </el-table-column>
                <el-table-column width="200" label="一级代理" align="center" prop="supplierName">
                    <template #default="scope">
                        <div :title="scope.row.supplierName" style="color: #377f7f;"
                             class="text-one cursor">
                            {{ scope.row.supplierName }}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column width="200" label="二级代理" align="center" prop="secondSupplierName">
                    <template #default="scope">
                        <div :title="scope.row.secondSupplierName" style="color: #377f7f;"
                             class="text-one cursor">
                            {{ scope.row.secondSupplierName }}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column width="100" align="center" label="卡绑定" prop="isActivate">
                    <template #default="scope">
                        <el-tag type="success" v-if="scope.row.isActivate === 1">已绑定</el-tag>
                        <el-tag type="info" v-if="scope.row.isActivate === 0">未绑定</el-tag>
                    </template>
                </el-table-column>
                <el-table-column  label="卡信息" width="200"  align="center" prop="cardNo">
                    <template #default="scope">
                        <div :title="scope.row.cardNo" style="color: #377f7f;"
                             class="text-one cursor">
                            {{ scope.row.cardNo }}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column width="100" align="center" label="卡类型" prop="cardType">
                    <template #default="scope">
                        <el-tag type="success" v-if="scope.row.cardType === 1">B卡</el-tag>
                        <el-tag type="success" v-if="scope.row.cardType === 2">C卡</el-tag>
                        <el-tag type="success" v-if="scope.row.cardType === 3">课程卡</el-tag>
                    </template>
                </el-table-column>

                <el-table-column fixed="right" label="操作" align="center" width="200">
                    <template #default="scope">
                        <el-button  type="primary" size="small" @click="handleUpdate(scope.row)">编辑</el-button>
                        <el-button  v-if="scope.row.isActivate === 0" type="success" size="small" @click="handleActive(scope.row)">激活</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <!--  分页  -->
        <div>
            <pagination :background="false" :pageSizes="[10, 20, 30]" :total="total"
                        v-model:page.sync="queryParams.pageNum"
                        v-model:limit.sync="queryParams.pageSize"
                        @pagination="pageList" />
        </div>
    </div>

    <el-dialog :title="'新增机构'" v-model="isInstitutionShow" width="60%" >
        <el-form ref="insFormRef" :model="insForm" :rules="insFormRules"
                 label-width="100px">
            <el-row>
                <el-col :span="12">
                    <el-form-item label="机构名称" prop="orgName">
                        <el-input v-model="insForm.orgName" placeholder="请输入机构名称"/>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="24">
                    <el-row :class="index !== 0 ? 'mt15' : ''" v-for="(item, index) in insForm.adminList" :key="index">
                        <el-col :span="12">
                            <el-form-item :label="'管理员' + (index + 1)" prop="adminUsername">
                                <div style="width: 100%;">
                                    <el-input v-model="item.username" placeholder="管理员账号" maxlength="32" />
                                </div>
                                <div style="width: 100%;margin-top: 5px">
                                    <el-input v-model="item.trueName" placeholder="管理员姓名" maxlength="32" />
                                </div>
                            </el-form-item>
                        </el-col>
                        <el-col :span="4" style="display: flex;align-items: center;">
                            <el-icon @click="createItemRow(index)" class="ml15 cursor" :size="30">
                                <CirclePlus />
                            </el-icon>
                            <el-icon v-if="index !== 0" @click="deleteItemRow(index)"
                                     class="ml15 cursor" :size="30">
                                <Remove />
                            </el-icon>
                        </el-col>
                    </el-row>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="12">
                    <el-form-item label="机构类别" prop="orgType">
                        <el-radio-group v-model="insForm.orgType">
                            <el-radio :label="1">组织</el-radio>
                            <el-radio :label="2">个人</el-radio>
                        </el-radio-group>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="试用时间" prop="orgTime">
                        <el-radio-group v-model="insForm.orgTime">
                            <el-radio :label="10">10天</el-radio>
                            <el-radio :label="20">20天</el-radio>
                        </el-radio-group>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="24">
                    <el-form-item label="试用卡类" prop="cardType">
                        <el-radio-group v-model="insForm.cardType">
                            <el-radio :label="1">B卡</el-radio>
                            <el-radio :label="2">C卡</el-radio>
                            <el-radio :label="3">课程卡</el-radio>
                        </el-radio-group>
                    </el-form-item>
                </el-col>
            </el-row>
        </el-form>
        <template #footer>
            <div class="dis-flex-row-center">
                <el-button type="primary" @click="submitInsForm">确 定</el-button>
                <el-button @click="isInstitutionShow = !isInstitutionShow">取 消</el-button>
            </div>
        </template>
    </el-dialog>

    <el-dialog :title="'机构编辑'" v-model="isInstitutionUpdateShow" width="60%" >
        <el-form ref="insFormRef" :model="insForm" :rules="insFormRules"
                 label-width="100px">
            <el-row>
                <el-col :span="12">
                    <el-form-item label="机构名称" prop="orgName">
                        <el-input v-model="insForm.orgName" placeholder="请输入机构名称"/>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="24">
                    <el-row :class="index !== 0 ? 'mt15' : ''" v-for="(item, index) in insForm.adminList" :key="index">
                        <el-col :span="12">
                            <el-form-item :label="'管理员' + (index + 1)" prop="adminUsername">
                                <div style="width: 100%;">
                                    <el-input v-model="item.username" placeholder="管理员账号" maxlength="32" />
                                </div>
                                <div style="width: 100%;margin-top: 5px">
                                    <el-input v-model="item.trueName" placeholder="管理员姓名" maxlength="32" />
                                </div>
                            </el-form-item>
                        </el-col>
                        <el-col :span="4" style="display: flex;align-items: center;">
                            <el-icon @click="createItemRow(index)" class="ml15 cursor" :size="30">
                                <CirclePlus />
                            </el-icon>
                            <el-icon v-if="index !== 0" @click="deleteItemRow(index)"
                                     class="ml15 cursor" :size="30">
                                <Remove />
                            </el-icon>
                        </el-col>
                    </el-row>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="12">
                    <el-form-item label="机构类别" prop="orgType">
                        <el-radio-group v-model="insForm.orgType">
                            <el-radio :label="1">组织</el-radio>
                            <el-radio :label="2">个人</el-radio>
                        </el-radio-group>
                    </el-form-item>
                </el-col>
            </el-row>
        </el-form>
        <template #footer>
            <div class="dis-flex-row-center">
                <el-button type="primary" @click="submitUpdateInsForm">确 定</el-button>
                <el-button @click="isInstitutionUpdateShow = !isInstitutionUpdateShow">取 消</el-button>
            </div>
        </template>
    </el-dialog>

    <el-dialog :title="'机构激活'" v-model="isActiveInstitution" width="320px" >
        <el-form ref="activeInsForm" :model="activeInsForm" :rules="activeInsFormRules"
                 label-width="90px">
            <el-row>
                <el-col :span="24">
                    <el-form-item label="机构名称" prop="orgName">
                        <el-input disabled v-model="activeInsForm.orgName" placeholder="请输入机构名称"/>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="24">
                    <el-form-item label="激活卡" prop="cardNo">
                        <el-select  v-model="activeInsForm.cardNo" placeholder="请选择激活卡">
                            <el-option v-for="item in stockCardList" :key="item.cardNo" :label="item.cardInfo"
                                       :value="item.cardNo" />
                        </el-select>
                    </el-form-item>
                </el-col>
            </el-row>
        </el-form>
        <template #footer>
            <div class="dis-flex-row-center">
                <el-button type="primary" @click="submitActiveForm">确 定</el-button>
                <el-button @click="isActiveInstitution = !isActiveInstitution">取 消</el-button>
            </div>
        </template>
    </el-dialog>

    <el-dialog :title="'用户导入'" v-model="isImportUserShow" width="300px">
        <el-form ref="reportForm" label-width="60px">
            <el-row style="width: 100%;">
                <el-col :span="24">
                    <el-form-item label="机构">
                        <el-select  v-model="orgId" placeholder="请选择导入机构">
                            <el-option v-for="item in dataList" :key="item.orgId" :label="item.orgName"
                                       :value="item.orgId" />
                        </el-select>
                    </el-form-item>
                </el-col>
            </el-row>
        </el-form>
        <template #footer>
            <div class="dis-flex-row-center disnone" style="align-items: unset;">
                <el-upload v-if="orgId" v-model:file-list="filesList" class="upload-demo"
                           :action="serviceUrl+'/businessservice/user/batchImport'"
                           :on-change="handleChange"
                           :headers="{ token }" :on-remove="handleRemove" :data="{ orgId: this.orgId }"
                           accept=".xlsx"
                           :before-upload="beforeUpload">
                    <el-button type="primary">上 传</el-button>
                </el-upload>
                <el-button class="ml15" @click="isImportUserShow = false">取 消</el-button>
            </div>
        </template>
    </el-dialog>
</template>
<script>
import {createOrg,updateOrg,activeOrg,pageOrg} from "@/api/admin/org";
import {listStockGeneral} from "@/api/admin/card";
import {secondSupplierInfo} from "@/api/admin/supplier";
import {timestampDate, timestampToTime} from "@/utils/date";
import {serviceUrl} from "@/utils/global";
import {download} from "@/utils/download";

export default {
    components: {},
    name: "supplier2OrgIndex",
    data() {
        return {
            serviceUrl,
            token: this.$storage.get("token"),
            timestampToTime,
            timestampDate,
            loading: false,
            /*分页查询机构*/
            queryParams:{
                supplierId:'',
                secondSupplierId:'',
                orgName:'',
                orgType:'',
                orgNature:'',
                pageNum: 1,
                pageSize: 10,
            },
            dataList:[],
            total:0,
            // 二级代理信息
            supplierId:'',
            supplierInfo:{},
            /*新增编辑机构*/
            isInstitutionShow:false,
            isInstitutionUpdateShow:false,
            insForm:{
                orgId:"",
                supplierId:"",
                secondSupplierId:"",
                orgName: '',
                orgType: 1, //组织类别:1-机构，2-个人
                parentId: '0',
                orgNature: "1", // 组织性质:1-试用,   2-正式
                orgTime: 10, // 试用天数
                cardType: 1, // 类型
                adminList: [{ username: '',trueName:'' }],
            },
            insFormRules: {
                orgName: [{ required: true, message: "请输入机构名称", trigger: "blur" },],
                orgType: [{ required: true, message: "请输入机构类别", trigger: "change" },],
                orgTime: [{ required: true, message: "请选择试用时间", trigger: "change" },],
                adminUsername: [{ required: true, validator: this.validateAdminAccount }],
            },
            /*机构激活*/
            isActiveInstitution:false,
            // 库存卡
            stockCardList:[],
            activeInsForm:{
                orgId:"",
                orgName: '',
                cardNo: '',
            },
            activeInsFormRules:{
                orgName: [{ required: true, message: "请输入机构名称", trigger: "blur" },],
                cardNo: [{ required: true, message: "请选择激活卡", trigger: "change" },],
            },
            // 用户导入
            orgId:'',
            filesList:[],
            isImportUserShow:false,
        }
    },
    computed: {},
    watch: {},
    created() {
        this.querySecondSupplierInfo();
    },
    mounted() {},
    methods: {
        downloadTemplate() {
            download('https://free-back.oss-cn-beijing.aliyuncs.com/ygjy/excel/%E5%8D%9A%E9%9B%85%E7%BE%8E%E8%82%B2%E7%94%A8%E6%88%B7%E5%AF%BC%E5%85%A5%E6%A8%A1%E6%9D%BF.xlsx', '用户导入模板')
        },
        /*===========代理============*/
        // 查询二级代理信息
        querySecondSupplierInfo(){
            secondSupplierInfo().then(res => {
                if (res.data.code === 1) {
                    this.supplierInfo = res.data.data;
                    this.supplierId = this.supplierInfo.supplierId;
                    this.insForm.supplierId = this.supplierInfo.parentId;
                    this.insForm.secondSupplierId = this.supplierId;
                    this.queryParams.secondSupplierId = this.supplierId;
                    this.pageList();
                }else {
                    this.$message.error("请求出错")
                }
            })
        },
        /*===========数据查询============*/
        handleQuery(){
            this.pageList(null);
        },
        pageList(e){
            this.loading = true
            this.dataList = [];
            if (e) {
                this.queryParams.pageNum = e.page;
                this.queryParams.pageSize = e.limit;
            }
            pageOrg(this.queryParams).then(res => {
                if (res.data.code === 1) {
                    this.total = res.data.data.total;
                    this.dataList = JSON.parse(JSON.stringify(res.data.data.list));
                    this.loading = false;
                }else {
                    this.$message.error("请求出错")
                    this.loading = false;
                }
            })
        },
        /*===========机构============*/
        createInstitution(){
            this.insForm.orgName = '';
            this.insForm.adminList = [{ username: '',trueName:'' }]
            this.isInstitutionShow = true;
        },
        submitInsForm(){
            this.$refs["insFormRef"].validate(valid => {
                if (valid) {
                    const adminList = [];
                    this.insForm.adminList.forEach(e => {
                        if (e.username) {
                            adminList.push({ username: e.username,trueName:e.trueName })
                        }
                    })
                    this.insForm.adminList = adminList;
                    createOrg(this.insForm).then(res => {
                        if (res.data.code === 1) {
                            this.pageList();
                            this.insForm.adminList = [{ username: '',trueName:'' }]
                            this.isInstitutionShow = false;
                        }else {
                            this.$message.error("请求出错")
                            this.insForm.adminList = [{ username: '',trueName:'' }]
                            this.isInstitutionShow = false;
                        }
                    })
                }
            })
        },
        handleUpdate(item){
            this.insForm.orgId = item.orgId;
            this.insForm.orgName = item.orgName;
            this.insForm.orgType = item.orgType;
            this.insForm.adminList = item.adminList;
            this.isInstitutionUpdateShow = true;
        },
        submitUpdateInsForm(){
            this.$refs["insFormRef"].validate(valid => {
                if (valid) {
                    const adminList = [];
                    this.insForm.adminList.forEach(e => {
                        if (e.username) {
                            adminList.push({ username: e.username,trueName:e.trueName })
                        }
                    })
                    this.insForm.adminList = adminList;
                    updateOrg(this.insForm).then(res => {
                        if (res.data.code === 1) {
                            this.pageList();
                            this.isInstitutionUpdateShow = false;
                        }else {
                            this.$message.error("请求出错")
                            this.isInstitutionUpdateShow = false;
                        }
                    })
                }
            })
        },
        /*===========机构激活============*/
        // 查询代理库存卡
        queryStockCardGeneral(itemId){
            listStockGeneral({supplierId:itemId}).then(res => {
                if (res.data.code === 1) {
                    this.stockCardList = res.data.data;
                }else {
                    this.$message.error("请求出错")
                }
            })
        },
        handleActive(item){
            this.stockCardList = [];
            this.activeInsForm.cardNo = '';
            this.activeInsForm.orgId = item.orgId;
            this.activeInsForm.orgName = item.orgName;
            this.isActiveInstitution = true;
            if (item.secondSupplierId){
                this.queryStockCardGeneral(item.secondSupplierId);
            }else {
                this.queryStockCardGeneral(item.supplierId);
            }
        },
        submitActiveForm(){
            this.$refs["activeInsForm"].validate(valid => {
                if (valid) {
                    activeOrg(this.activeInsForm).then(res => {
                        if (res.data.code === 1) {
                            this.$message.success("激活成功")
                            this.pageList();
                            this.isActiveInstitution = false;
                        }else {
                            this.$message.error("请求出错")
                            this.isActiveInstitution = false;
                        }
                    })
                }
            })
        },
        /*===========用户导入============*/
        importUser(){
            this.orgId = "";
            this.isImportUserShow = true;
        },
        beforeUpload(rawFile) {
            if (!(rawFile.type == 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet')) {
                this.$message.error('文件格式有误')
                return false
            } else if (rawFile.size / 1024 / 1024 > 20) {
                this.$message.error('文件大小不能超过20M')
                return false
            }
            return true
        },
        handleRemove(file, uploadFiles) {
        },
        handleChange(e, type) {
            if (e.response) {
                if (e.response.code === 1) {
                    this.$message.success('用户导入成功')
                    this.orgId = '';
                    this.isImportUserShow = false;
                } else {
                    if (e.response.msg) {
                        this.$message.error(e.response.msg)
                    } else {
                        this.$message.error('用户导入失败')
                    }
                }
            }
            if (e.status === 'fail') {
                this.$message.error('用户导入失败')
            }
        },
        /*===========数据校验============*/
        validateAdminAccount(rule, value, callback) {
            let tg = 0;
            this.insForm.adminList.forEach(e => {
                if (e.username) {
                    tg++;
                }
            })
            if (tg === 0) {
                callback(new Error('请输入管理员信息'));
            } else {
                this.insForm.adminList.forEach(e => {
                    if (!e.username|| !e.trueName) {
                        callback(new Error('请完善管理员信息'));
                    }
                })
                callback();
            }
        },
        createItemRow(i) {
            this.insForm.adminList.splice((i + 1), 0, {
                username: ''
            })
        },
        deleteItemRow(i) {
            this.insForm.adminList.splice(i, 1)
        },
    },
}
</script>
<style scoped>
.admin-input1 /deep/ .el-input__wrapper {
    height: 30px; /* 高度 */
    line-height: 28px;
    min-height: 30px!important;
}
.name-search-btn{
    background-color: #377f7f!important;
    color: #fff!important;
}

</style>
